/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import { ExpandCollapse, Typography } from '@telus-uds/components-web';
import FormSummaryRow from '../formSummaryRow';
import { GroupWrapper, GroupTitle } from '../css';
import {
  BACKEND_KEYS,
  additionalEquipment,
  easyAdditionalEquipment,
  oneTimeAdditionalEquipment,
  fieldWinbackFibre,
  valueNewTelusBusinessOrder,
  fieldWinback,
  fieldAddProductVulcan,
  fieldBusinessConnectVulcan
} from '../../utils/constant';

import { getLocalizedStrings } from '../../misc';
import { get } from 'lodash';
import { TableCS } from './cybersecurityTableSummary';

const userDetailsKey = 'userDetails';
const formSectionKey = 'formSection';
const repeatedFormKey = 'repeatedForm';
const formFieldsGroup = 'formFieldsGroup';

const removePrice = label => {
  if (!label || typeof label !== 'string') return label;
  return label.replace(/\([\D\s]*\$[\d.\s\D]*\)/g, '');
};

const priceClean = label => {
  if (Array.isArray(label)) {
    return label.map(filteredLabel => {
      return removePrice(filteredLabel);
    });
  }
  return removePrice(label);
};

export const getFieldLabel = (options, fieldValue) => {
  if (!options || !options.length) {
    if (Array.isArray(fieldValue)) {
      return (
        fieldValue &&
        fieldValue.length > 0 &&
        fieldValue.map(field => priceClean(field))
      );
    }
    return priceClean(fieldValue);
  }
  for (let i = 0; i < options.length; i += 1) {
    const option = options[i];
    const fields = option.fields || {};
    const { label, value } = fields || {};
    if (value === fieldValue) {
      return priceClean(label);
    }
  }

  if (Array.isArray(fieldValue) && fieldValue.length === 0) {
    return null;
  }
  return priceClean(fieldValue);
};

const CybersecurityOrderSummary = ({ stepData, orderData }) => {
  if (!Array.isArray(stepData)) {
    return null;
  }
  const stepSummaryData = stepData.slice(0, 3);

  const productName = get(orderData, fieldAddProductVulcan, []);
  const orderIdTSBValue = get(orderData, 'orderIdTSB', '');
  const isProductVisible = (name, productName) => {
    if (
      name === 'Fibre Internet' &&
      productName.includes('Fibre Internet')
    ) {
      return true;
    }

    if (
      name === 'secureBusinessProductVulcan' &&
      productName.includes('Telus Secure Business') &&
      !orderIdTSBValue
    ) {
      return true;
    }

    if (name === 'Business Wi-Fi' && productName.includes('Business Wifi')) {
      return true;
    }

    if (name === 'customerInformationVulcan') {
      return true;
    }

    return false;
  };

//   const isSectionVisisble = stepBackendKey => {
//     if (
//       stepBackendKey === ' additionalCustomerInformation' &&
//       (productName.includes(fieldBusinessConnectVulcan) || orderIdTSBValue)
//     ) {
//       return false;
//     }
//     return true;
//   };

  const {
    contentfulValues: { yes, no }
  } = getLocalizedStrings();

  // Function to handle boolean values
  const handleBooleanValue = value => {
    return value ? yes : no;
  };

  // Function to handle field values
  const handleFieldValue = (backendKey, value) => {
    if (typeof value === 'boolean') {
      return handleBooleanValue(value);
    }
    return value;
  };

  const groupSummary = (
    fieldNamesArray,
    formStepFieldsArray,
    groupOrderData
  ) => {
    return formStepFieldsArray.map((formStepFields, index) => {
      if (!formStepFields) return null;
      const nonEmptyFields =
        formStepFields &&
        formStepFields.filter(currentField => {
          const {
            fields: { backendKey }
          } = currentField || {};
          const isObject = typeof groupOrderData[backendKey] === 'object';
          const isArray = Array.isArray(groupOrderData[backendKey]);
          if (isObject && !isArray) {
            return !!groupOrderData[backendKey].value;
          }
          if (isArray && groupOrderData[backendKey].length) {
            return true;
          }
          return !!groupOrderData[backendKey];
        });

      if (!nonEmptyFields || !nonEmptyFields.length) return null;
      const setTitle = label => {
        if (label === additionalEquipment) {
          return `${label} (${oneTimeAdditionalEquipment})`;
        }
        if (label === easyAdditionalEquipment) {
          return `${additionalEquipment} (${label})`;
        }
        return label;
      };
      return (
        <GroupWrapper key={index} style={{ marginBottom: '1em', paddingLeft: 0, paddingRight: 0 }}>
          <GroupTitle style={{ marginBottom: '0.5em' }}>
            {setTitle(fieldNamesArray[index])}
          </GroupTitle>
          {nonEmptyFields &&
            nonEmptyFields.map(({ fields: { backendKey, label, options } }) => {
              let fieldValue = '';
              const isArray = Array.isArray(groupOrderData[backendKey]);
              const isObject = typeof groupOrderData[backendKey] === 'object';
              if (isObject && !isArray) {
                fieldValue = priceClean(groupOrderData[backendKey].value);
              } else if (isArray) {
                fieldValue = groupOrderData[backendKey]
                  .join(', ')
                  .split(',')
                  .map(item => priceClean(item))
                  .join(',');
              } else {
                fieldValue = priceClean(groupOrderData[backendKey]);
              }
              fieldValue = handleFieldValue(backendKey, fieldValue);
              const labelLogic =
                fieldNamesArray[index] &&
                fieldNamesArray[index] === additionalEquipment
                  ? priceClean(label)
                  : priceClean(label);
              return (
                <FormSummaryRow
                  key={backendKey}
                  label={labelLogic}
                  value={getFieldLabel(options, fieldValue)}
                  isDollarRemove
                />
              );
            })}
        </GroupWrapper>
      );
    });
  };

  const handleFormSummaryRow = (
    {
      fieldLabel,
      fieldBackendKey,
      fieldName,
      formStepFields,
      contentfulId,
      formTitle,
      options: mainOptions,
      appearsAfterValue,
      appearsAfterField,
      easyPaymentFields,
      easyPaymentTitle
    },
    customOrderData
  ) => {
    const dataOrder = customOrderData || orderData;

    if (
      (fieldName === fieldWinbackFibre || fieldName === fieldWinback) &&
      dataOrder.orderType !== valueNewTelusBusinessOrder
    )
      return null;
    if (contentfulId === userDetailsKey) {
      return groupSummary([fieldName], [formStepFields], dataOrder);
    }
    if (contentfulId === formFieldsGroup) {
      return groupSummary([fieldName], [formStepFields], dataOrder);
    }
    if (contentfulId === formSectionKey) {
      return (
        formStepFields &&
        formStepFields.length > 0 &&
        formStepFields.map(item => {
          const {
            fields: {
              label,
              backendKey,
              name: sectionFieldName,
              fields: groupFields,
              formFields: sectionFormFields,
              title,
              formTitle: sectionFormTitle
            },
            sys: {
              contentType: {
                sys: { id: fieldContentfulId }
              }
            }
          } = item || {};
          const rowObj = {
            fieldLabel: label,
            fieldBackendKey: backendKey,
            fieldName: sectionFieldName || title,
            formStepFields: groupFields || sectionFormFields,
            contentfulId: fieldContentfulId,
            formTitle: title || sectionFormTitle
          };
          return handleFormSummaryRow(rowObj, customOrderData);
        })
      );
    }
    if (contentfulId === repeatedFormKey) {
      return (
        dataOrder[fieldName] &&
        dataOrder[fieldName].map((row, idx) =>
          groupSummary([`${formTitle} ${idx + 1}`], [formStepFields], row)
        )
      );
    }
    const fieldKey =
      (dataOrder[fieldBackendKey] && fieldBackendKey) || fieldName;
    let fieldValue = getFieldLabel(mainOptions, dataOrder[fieldKey]);

    // Check if the type can be converted to float
    let typeCheckedFieldValue = parseFloat(fieldValue);

    // Check if the value really is in decimals and needs rounding off
    if (typeCheckedFieldValue && typeCheckedFieldValue % 1 !== 0) {
      typeCheckedFieldValue = typeCheckedFieldValue.toFixed(2);
    } else if (typeof fieldValue === 'boolean') {
      typeCheckedFieldValue = handleBooleanValue(fieldValue);
    } else {
      typeCheckedFieldValue = fieldValue;
    }

    return (
      <FormSummaryRow
        key={fieldBackendKey}
        label={fieldLabel}
        value={typeCheckedFieldValue}
        isDollarRemove
      />
    );
  };

  const rowCb = (formStepFields, customOrderData) => {
    return formStepFields.map(formStepField => {
      const {
        fields: {
          label: fieldLabel,
          outputLabel,
          backendKey: fieldBackendKey,
          formStepFields: subStepFields,
          easyPaymentFields,
          easyPaymentTitle,
          formFields: repeatedGroupFields,
          appearsAfterField,
          appearsAfterValue,
          fields: groupFields,
          name: fieldName,
          title: groupTitle,
          formTitle,
          options
        },
        sys: {
          contentType: {
            sys: { id: contentfulId }
          }
        }
      } = formStepField;
      const isValidRow = contentfulId !== 'equipmentGroupSection';
      if (fieldName === 'termCS') {
        return <TableCS fieldData={orderData['tableCybersecurity']['selection']} />;
      }
      return (
        <React.Fragment key={fieldBackendKey}>
          {isValidRow &&
            handleFormSummaryRow(
              {
                fieldLabel: outputLabel || fieldLabel,
                fieldBackendKey,
                formStepFields:
                  subStepFields ||
                  repeatedGroupFields ||
                  groupFields ||
                  formStepFields,
                fieldName: fieldName || groupTitle,
                contentfulId,
                formTitle: formTitle || groupTitle,
                options,
                appearsAfterField,
                appearsAfterValue,
                easyPaymentFields,
                easyPaymentTitle
              },
              customOrderData,
              formStepFields
            )}
        </React.Fragment>
      );
    });
  };

//   const handelQuotePage = formStepFields => {
//     return formStepFields.map(
//       ({ fields: { title: title, name: name, formFields } }) =>
//         [
//           'customerInformationVulcan',
//           'Fibre Internet',
//           'Business Wi-Fi',
//           'secureBusinessProductVulcan'
//         ].includes(name) &&
//         isProductVisible(name, productName) && (
//           <ExpandCollapse.Panel id={name} header={title} key={name}>
//             {formFields && rowCb(formFields)}
//           </ExpandCollapse.Panel>
//         )
//     );
//   };

  return (
    <>
      <ExpandCollapse>
        {(expandProps) => (
          <>
            {stepSummaryData &&
              stepSummaryData.map(
                ({
                  fields: {
                    name: stepName,
                    backendKey: stepBackendKey,
                    formStepFields
                  }
                }) =>
                  stepBackendKey !== 'orderSummary' && (
                    <ExpandCollapse.Panel
                      {...expandProps}
                      panelId={stepBackendKey}
                      control={<Typography variant={{ size: 'h2' }}>{stepName}</Typography>}
                      key={stepBackendKey}
                    >
                      {formStepFields.map(index => rowCb(index.fields.formFields))}
                    </ExpandCollapse.Panel>
                  )
              )}
          </>
        )}
      </ExpandCollapse>
    </>
  );
};

CybersecurityOrderSummary.propTypes = {
  stepData: PropTypes.objectOf(PropTypes.any).isRequired,
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  isQuestionVisible: PropTypes.bool.isRequired
};

export default CybersecurityOrderSummary;
